<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="ORIM-Book-Title--Front-Matter-"><span class="CharOverride-1">The Torrents of Spring</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><span class="CharOverride-1">Ernest Hemingway</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><img alt="logo" src="logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled4.vue?18891f07